import { render, staticRenderFns } from "./RecipientInfoSection.vue?vue&type=template&id=57c52216&scoped=true&"
import script from "./RecipientInfoSection.vue?vue&type=script&lang=js&"
export * from "./RecipientInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./RecipientInfoSection.vue?vue&type=style&index=0&id=57c52216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c52216",
  null
  
)

export default component.exports